(function () {
  function init(root) {
    if (root.dataset.ready) return; root.dataset.ready = 1;
    var P = window.PuddlePricing, $ = function (s) { return root.querySelector(s); };
    var variants = JSON.parse($('[data-variants]').textContent || '{}');
    var dEl = $('[data-d]'), hEl = $('[data-h]'), btn = $('[data-add]'), err = $('[data-err]');
    function state() {
      var d = parseFloat(dEl.value), h = parseFloat(hEl.value), e = P.validate(d, h);
      var price = e.length ? null : P.price(d, h), vid = price && variants[String(price)];
      if (price && !vid) e.push('This size needs a custom quote — please contact us.');
      return { d: d, h: h, errors: e, price: price, vid: vid };
    }
    function render() {
      var s = state();
      $('[data-w]').textContent = s.errors.length && !s.price ? '–' : P.weight(s.d, s.h).toFixed(1);
      $('[data-p]').textContent = s.price ? '$' + s.price.toLocaleString('en-US', { minimumFractionDigits: 2 }) : '–';
      err.textContent = s.errors.join(' '); btn.disabled = !!s.errors.length; return s;
    }
    dEl.addEventListener('input', render); hEl.addEventListener('input', render);
    btn.addEventListener('click', function () {
      var s = render(); if (s.errors.length) return; btn.disabled = true;
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: s.vid, quantity: 1, properties: {
          'Diameter (in)': String(s.d), 'Height (in)': String(s.h),
          'Est. weight (lb)': P.weight(s.d, s.h).toFixed(1), '_quoted_price': String(s.price) } }] })
      }).then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
          .then(function (res) { if (typeof window.PuddleCustomOnAdded === 'function') return window.PuddleCustomOnAdded(res, s); window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart'; })
        .catch(function () { err.textContent = 'Could not add to cart — please try again.'; btn.disabled = false; });
    });
    render();
  }
  function boot() { document.querySelectorAll('.puddle-custom').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
